module.exports = __webpack_public_path__ + "img/editBanner_a.044ab1ba.png";